import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'browser-dialog',
  templateUrl:
    'console/app-js/modules/security/component/browser-dialog/browser-dialog.component.html'
})
export class BrowserDialogComponent {
  @Input('opened') opened = false;
  @Output() closed = new EventEmitter<any>();

  public open() {
    this.opened = true;
  }

  public close() {
    this.opened = false;
    this.closed.emit();
  }
}
